import { withFormController } from '../../../../../../../../../../components/hocs/forms';
import LanguageCurrencyFieldBase from '../../../../../../../../../../components/inputs/LanguageCurrencyField';
import TextFieldBase from '../../../../../../../../../../components/inputs/text-fields/base/TextFieldBase';

export const stripSpecialChars = (_value: string, originalValue: string) => {
  if (!originalValue) {
    return 0;
  }

  return Number(String(originalValue)?.replace(/[^\d.]/g, ''));
};

export const ControlledTextField = withFormController(TextFieldBase);
export const ControlledLanguageCurrencyField = withFormController(
  LanguageCurrencyFieldBase
);
